module.exports = __webpack_public_path__ + "img/dashboard.1b2c6bb3.jpg";